import { parseQueryParams } from '../helpers/URLHelper';
export class Configuration {
  static configuration = null;
  static colors = {};

  constructor() {
    this.pilotId = "10008";
    this.clientId = "heh10";
    this.logoCssClass = "nve-dashboard-logo";
    this.preview = false;
  }

  static setColors(colorsToReplace) {
    this.colors = colorsToReplace;
  }

  static getColors() {
    return {
      colors: this.colors
    };
  }

  static getConfiguration() {
    if(this.configuration) {
      return this.configuration;
    }
    if(typeof (window) === "undefined") {
      this.configuration = new Configuration();
      return this.configuration;
    }

    const host = window.location.host;

    if (ConfigurationDuke.isDomainSupported(host)) {
      this.configuration = new ConfigurationDuke();
    }
    else if (ConfigurationSCG.isDomainSupported(host)) {
      this.configuration = new ConfigurationSCG();
    }
    else if (ConfigurationNVE.isDomainSupported(host)) {
      this.configuration = new ConfigurationNVE();
    }
     else if (ConfigurationSimply.isDomainSupported(host)) {
      this.configuration = new ConfigurationSimply();
    }
    else if (ConfigurationCOH.isDomainSupported(host)) {
      this.configuration = new ConfigurationCOH();
    }
     else if (ConfigurationHydroottawa.isDomainSupported(host)) {
      this.configuration = new ConfigurationHydroottawa();
    }
     else if (ConfigurationFPL.isDomainSupported(host)) {
      this.configuration = new ConfigurationFPL();
    } else if (ConfigurationDemo.isDomainSupported(host)) {
      this.configuration = new ConfigurationDemo();
    } else if(ConfigurationPreview.isDomainSupported(host)) {
      this.configuration = new ConfigurationPreview();
    } else {
      this.configuration = new Configuration();
    }

    return this.configuration;
  }
}

class ConfigurationDuke extends Configuration {
  constructor() {
    super();
    this.pilotId = "10010";
    this.clientId = "duke-dashboard";
  }

  static isDomainSupported(host) {
    return new RegExp(/^duke(-?)([a-z]*[0-9]*)\.bidgely\.com$/).test(host);
  }
}


class ConfigurationSCG extends Configuration {
  constructor() {
    super();
    this.pilotId = "10033";
    this.clientId = "scg-dashboard";
    this.logoCssClass = "scg-logo";
  }

  static isDomainSupported(host) {
    return new RegExp(/^scg(-?)([a-z]*[0-9]*)\.bidgely\.com$/).test(host);
  }
}

class ConfigurationNVE extends Configuration {
  constructor() {
    super();
    this.pilotId = "10009";
    this.clientId = "nve-dashboard";
  }

  static isDomainSupported(host) {
    return new RegExp(/^nve(-?)([a-z]*[0-9]*)\.bidgely\.com$/).test(host);
  }
}

class ConfigurationSimply extends Configuration {
  constructor() {
    super();
    this.pilotId = "10030";
    this.clientId = "simply-dashboard";
  }

  static isDomainSupported(host) {
    return new RegExp(/^simplyenergy([0-9]*[a-z]*)\.bidgely\.com$/).test(host);
  }
}

class ConfigurationCOH extends Configuration {
  constructor() {
    super();
    this.pilotId = "10032";
    this.clientId = "coh-dashboard";
    this.logoCssClass = "coh-logo";
  }

  static isDomainSupported(host) {
    return new RegExp(/^coh(-?)([a-z]*[0-9]*)\.bidgely\.com$/).test(host);
  }
}

class ConfigurationHydroottawa extends Configuration {
  constructor() {
    super();
    this.pilotId = "10008";
    this.clientId = "heh10";
  }

  static isDomainSupported(host) {
    return (new RegExp(/^hydro-ottawa(-?)([a-z]*[0-9]*)\.bidgely\.com$/).test(host)) || (new RegExp(/^hydroottawa(-?)([a-z]*[0-9]*)\.bidgely\.com$/).test(host));
  }
}

class ConfigurationFPL extends Configuration {
  constructor() {
    super();
    this.pilotId = "10017";
    this.clientId = "fpl-dashboard";
  }

  static isDomainSupported(host) {
    return new RegExp(/^fpl(-?)([a-z]*[0-9]*)\.bidgely\.com$/).test(host);
  }
}

class ConfigurationDemo extends Configuration {
  constructor() {
    super();
    this.pilotId = "10034";
    this.clientId = "ubc-dashboard";
    this.logoCssClass = "utility-logo";
  }

  static isDomainSupported(host) {
    return new RegExp(/^ubc(-?)([a-z]*[0-9]*)\.bidgely\.com$/).test(host);
  }
}

class ConfigurationPreview extends Configuration {

  constructor() {
    super();
    let queryParams = parseQueryParams(window.location.search);

    this.pilotId = queryParams['pilot-id'];
    this.clientId = queryParams['client-id'];
    this.logoCssClass = "utility-logo";
    this.preview = true;
  }

  static isDomainSupported(host) {
    return new RegExp(/^preview(-?)([a-z]*[0-9]*)\.bidgely\.com$/).test(host);
  }
}
